/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["fieldset[_ngcontent-%COMP%]{border:1px solid #d3d3d3}"];
export { styles as styles };
